import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var getImageInfo = normalize.getImageInfo(function (args) {
  var image = new Image();
  image.src = args.src;

  if (image.naturalWidth) {
    var res = {
      width: image.naturalWidth,
      height: image.naturalHeight,
      path: args.src
    };
    args.success(res);
    args.complete(res);
  } else {
    var setImageInfo = function setImageInfo() {
      var res = {
        width: image.width,
        height: image.height,
        path: args.src
      };
      args.success(res);
      args.complete(res);
    };

    if (image.complete) {
      setImageInfo();
    } else {
      var checkTimer = null;

      var clear = function clear() {
        clearInterval(checkTimer);
        checkTimer = null;
      };

      checkTimer = setInterval(function () {
        if (image.width > 0 || image.height > 0) {
          setImageInfo();
          clear();
        }
      }, 40);

      image.onload = function () {
        if (checkTimer) {
          setImageInfo();
          clear();
        }
      }; // eslint-disable-next-line no-multi-assign


      image.onabort = image.onerror = function (e) {
        args.fail(e);
        args.complete(e);
        clear();
      };
    }
  }
}, CONTAINER_NAME.WEB);
export default getImageInfo;